module.exports = __webpack_public_path__ + "img/block02_h5.7e03ea69.webp";